import HELPER from '@/app/utils/HELPER';
import { AtomServiceExportData } from '@/app/editor/iframe/atom/atom-service/export/AtomServiceExportData';
import { DataManager } from '@/app/editor/iframe/atom/service/DataManager';
import { base } from '@/app/editor/sidebar/constant';

/**
 * GpChildProductExportService
 */
export default class GpChildProductExportService extends AtomServiceExportData {
  /**
   * renderTemplateExport
   * @override AtomServiceExportData.renderTemplateExport
   * @param $atomClone :JQuery
   * @param html :string
   * @returns $atomClone :JQuery
   */
  renderTemplateExport($atomClone: JQuery, html: string): JQuery {
    let templateTmp = this.atom.getDataBkSettingByKey(base._template);
    const $settings = this.atom.getDataBkSettingByKey(base._settings);

    let fields = [];
    try {
      fields = jQuery.parseJSON($settings);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err.message);
    }

    templateTmp = HELPER.replaceFields(fields, templateTmp);
    // LƯU Ý: Các sase dưới đây, cần check bên trong hàm deExportMe cửa gfModule
    //  để override lại function cloneAtom();
    // (P) Title, (P) Vendor, (P) SKU, (P) Description, (P) Variants, (P) Swatches, (P) Price, (P) Quantity, (P) Image, (P) Image List, (P) Stock Counter, (P) Cart Button, (P) View More, (P) Meta
    $atomClone = this.cloneAtom($atomClone, templateTmp);
    return $atomClone;
  }

  /**
   * cloneAtom
   * @param $atomClone :jQuery
   * @param templateTmp :string
   * @returns $atomClone
   */
  cloneAtom($atomClone: JQuery, templateTmp: string): JQuery {
    return $atomClone.html(templateTmp);
  }

  /**
   * @override get$bkCloneHtml
   * @param $bkClone $bkClone
   * @returns returns
   */
  get$bkCloneHtml($bkClone: JQuery): JQuery {
    const $bk = jQuery('<div />').append($bkClone);
    const atomModel = DataManager.getDataSetting(this.atom.getId()).atom;
    const settingsString = JSON.stringify(atomModel.settings);
    $bk.find('.settings').html(settingsString);
    return $bk;
  }
}
